'use client';

import { useEffect } from 'react';

export const AddVariableToGtmDataLayer = ({
  isVerified,
}: {
  isVerified: boolean;
}) => {
  useEffect(() => {
    window.dataLayer?.push({
      event: 'userStatus',
      is_verified: isVerified, // Change this value to test dynamic data
    });
  }, [isVerified]);
  return <></>;
};
